<template>
	<view v-if="visible" id="mask" @click.stop="close">
		<view id="content">
			<!-- 新增标题插槽 -->
			<view id="title">
				<slot name="header">
					温馨提示
				</slot>
			</view>
			<!-- 默认插槽 -->
			 <view id="body">
				<slot>默认遮罩内容</slot>
			 </view>
			
			<!-- 新增底部按钮插槽 -->
			<button @click.stop="close" class="footer">
				<slot name="footer">
					确定
				</slot>
			</button>

		</view>
	</view>
</template>

<script>
export default {
	name: "nsh_mask",
	model: {
		prop: 'visible',
		event: 'toggle'
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit("toggle", false);
		}
	}
};
</script>

<style lang="scss" scoped scoped>
#mask {
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 1000;
	top: 0;
	left: 0;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;

	#content {
		
		background-color: white;
		padding: 0;
		padding-bottom: 30rpx;
		border-radius: 10rpx;
		width: 700rpx;

		#title {
			background-color: #F9FAFC;
			height:88rpx;
			line-height: 88rpx;
			font-size: 34rpx;
			font-weight: bold;
			margin-bottom: 20rpx;
			text-align: center;
			border-top-left-radius: 10rpx;
			border-top-right-radius: 10rpx;
			color:#221715;
		}
		#body{
			min-height:400rpx;
			padding:0 30rpx;	
		}
		.footer {
			width:650rpx;
			font-size: 30rpx;
			color: #221715;
			background-color: #fcc800;
			height: 80rpx;
			line-height: 80rpx;
			margin-top: 60rpx;
			margin:0 auto;
			position: inherit;
		}
	}
}
</style>